import React from "react";
import { Link } from "react-router-dom";
import { typeSidebarMenu } from "./index";
import { classNames } from "../../../../utils";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/outline";

export const ViewComponent: React.FC<typeSidebarMenu> = ({ data, onClick }) => {
  return (
    <>
      {data.map((item) =>
        !item.children ? (
          <Link
            key={item.id}
            id={item.id}
            to={item.href}
            onClick={onClick}
            className={classNames(
              item.current
                ? "bg-gray-900 text-white"
                : "text-gray-300 hover:bg-primary-600",
              "group flex items-center px-2 py-2 text-sm font-medium rounded-md",
            )}
          >
            <item.icon
              className={classNames(
                item.current
                  ? "text-gray-300"
                  : "text-gray-400 group-hover:text-gray-300",
                "mr-3 flex-shrink-0 h-6 w-6",
              )}
              aria-hidden="true"
            />
            {item.name}
          </Link>
        ) : (
          <Disclosure
            as="div"
            key={item.id}
            className="space-y-1"
            defaultOpen={item.current}
          >
            {({ open }) => (
              <>
                <Disclosure.Button
                  className={classNames(
                    item.current && !open
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-primary-600",
                    "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500",
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "text-gray-300"
                        : "text-gray-400 group-hover:text-gray-300",
                      "mr-3 flex-shrink-0 h-6 w-6",
                    )}
                    aria-hidden="true"
                  />
                  <span className="flex-1">{item.name}</span>
                  {open ? (
                    <ChevronDownIcon className="text-gray-400 ml-3 flex-shrink-0 h-4 w-4" />
                  ) : (
                    <ChevronRightIcon className="text-gray-300 group-hover:text-gray-300 ml-3 flex-shrink-0 h-4 w-4" />
                  )}
                </Disclosure.Button>
                <Disclosure.Panel className="space-y-1">
                  {/* @ts-ignore */}
                  {item.children.map((subItem) => (
                    <Link
                      id={subItem.id}
                      key={subItem.id}
                      to={subItem.href}
                      onClick={onClick}
                      className={classNames(
                        subItem.current
                          ? "bg-gray-900"
                          : "hover:text-gray-300 hover:bg-primary-600",
                        "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-300 rounded-md",
                      )}
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ),
      )}
    </>
  );
};
